import(/* webpackMode: "eager" */ "/app/src/app/language/[code]/qna/page.tsx");
